
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftLeft100 as ObiThreewayAnalogInleftLeft100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-left-100.js';
 
 
 

 
 export const ObiThreewayAnalogInleftLeft100 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-left-100',
   elementClass: ObiThreewayAnalogInleftLeft100Element,
   events: {
     
   }
  });
 
 